import styled from 'styled-components';
import { colors } from "../../../common/ui/globalColors";

export const StyledPdfWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    .pdf-title {
        font-size: 30px;
        text-align: center;
        font-weight: 700;
        margin-bottom: 20px;
        border-bottom: 1px solid black;
        width: fit-content;
    }

    .pdf-note {
        margin: 100px 0 200px;
        align-self: start;
    }

    .pdf-rows-wrapper {
        font-size: 20px;
        width: 100%;
        
        .pdf-row {
            direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
            display: flex;
            padding: 10px;
            padding-inline-start: 50px;

            img {
                display: none;
            }

            :nth-child(2n) {
                background-color: ${colors.additionalColors.lightGray};
            }

            div {
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
            }
            
            .debt {
                flex-basis: 25%;
            }

            .yearly-apt {
                flex-basis: 12%;
                font-size: 15px;
                word-break: break-all;
            }

            .yearly {
                flex-basis: 5.5%;
                font-size: 15px;
            }

            .expenses {
                flex-basis: 14%;
            }

            .monthly-report {
                flex-basis: 10%;
                max-width: 10%;
                overflow-wrap: anywhere;
            }

            .pdf-highlited {
                font-weight: 700;
            }
        }

        @media print {
            .pdf-row {
                padding-inline-start: 10px;
            }
        }
    }

`
